import styled from 'styled-components';

import { CalendarTodayRounded as MuiCalendarTodayRounded } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

export const CalendarTodayRounded = styled(MuiCalendarTodayRounded)`
  fill: ${wellzTheme.palette.primary.main};
`;

export const BookedTo = styled(Typography)`
  font-weight: 500;
  display: inline-block;
`;
